<template>
  <div class="justify-center text-center py-7 mx-auto" style="width: 90vw">
    <v-container fluid>
      <MedlemsData :memberId="id"/>
      <MedlemsBetalinger :memberId="id"/>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import MedlemsData from '@/components/MedlemsData.vue'
import MedlemsBetalinger from '@/components/MedlemsBetalinger.vue'

export default {
  name: 'Medlemsinfo',
  components: {
    MedlemsData,
    MedlemsBetalinger
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  }
}
</script>
